export const SharedLinksTableActionsEnum = {
  ReactivateLink: { val: 0, name: 'ReactivateLink' },
  DeactivateLink: { val: 1, name: 'DeactivateLink' },
  DeleteLink: { val: 2, name: 'DeleteLink' },
};
